import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const ElectricCrossoverForklifts = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Elektrické terénní vozíky</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-s25-35xe.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK s25-35xe"
          title="CLARK série S25XE/30/35"
          loadCapacity="2 500 - 3 500 kg"
          drive="Elektrický"
          liftHeight="2 120 - 7 315 mm"
          maxSpeed="až 18 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/s25-30-35xe?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
          isNew={true}
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-L25-35xe.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK L25-35xe"
          title="CLARK série L25XE/30/35"
          loadCapacity="2 500 - 3 500 kg"
          drive="Elektrický"
          liftHeight="1 985 - 7 315 mm"
          maxSpeed="až 19 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/l25-30-35xe?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
          isNew={true}
        />
      </div>
    </div>
  );
};
export default ElectricCrossoverForklifts;
